// extracted by mini-css-extract-plugin
export default {"wrapper":"QRCodeDepositResult_wrapper--Wa6"};